// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31QXy","type":"styles_type__29S0o","choices":"styles_choices__psuGM"};